import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("el-dialog", {
    attrs: {
      visible: true,
      title: "溯源批次选择"
    },
    on: {
      close: function close($event) {
        return _vm.sel(null);
      }
    }
  }, [_c("div", [_c("el-form", {
    attrs: {
      inline: true,
      size: "mini"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "产品名称"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "产品名称"
    },
    model: {
      value: _vm.searchForm.productName,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "productName", $$v);
      },
      expression: "searchForm.productName"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.search
    }
  }, [_c("i", {
    staticClass: "fa fa-search"
  }), _vm._v(" 查询")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.queryLoading,
      expression: "queryLoading"
    }],
    staticStyle: {
      width: "100%",
      "margin-bottom": "20px"
    },
    attrs: {
      data: _vm.tableData,
      stripe: "",
      border: "",
      "row-key": "id",
      "element-loading-text": "正在努力加载中..."
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "操作",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            size: "mini",
            type: "warning"
          },
          on: {
            click: function click($event) {
              return _vm.sel(scope.row);
            }
          }
        }, [_vm._v("选择")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "productName",
      label: "产品名称",
      "min-width": "100",
      "show-overflow-tooltip": ""
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "sourceBatchCode",
      label: "批次",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productAmount",
      label: "数量",
      "min-width": "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productShelfLife",
      label: "保质期",
      "min-width": "150"
    }
  })], 1), _c("el-pagination", {
    attrs: {
      background: "",
      align: "center",
      layout: "prev, pager, next, sizes, total",
      "page-sizes": [10, 20, 50, 100],
      "current-page": _vm.searchForm.page,
      "page-size": _vm.searchForm.limit,
      total: _vm.totalCount
    },
    on: {
      "current-change": _vm.pageChange,
      "size-change": _vm.sizeChange
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };